import { render, staticRenderFns } from "./TSublime.vue?vue&type=template&id=e830b55e&scoped=true&"
import script from "./TSublime.vue?vue&type=script&lang=js&"
export * from "./TSublime.vue?vue&type=script&lang=js&"
import style0 from "./TSublime.vue?vue&type=style&index=0&id=e830b55e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e830b55e",
  null
  
)

export default component.exports